<slotcom-navigation-button
  type="close"
  (click)="closeModal()">
</slotcom-navigation-button>

<div class="c-rateModal">
  <div class="c-rateModal__background">
    <div class="c-rateModal__gameIconContainer">
      <div
        class="c-rateModal__gameIcon"
        [ngStyle]="gameIcon"></div>
    </div>

    <div class="c-rateModal__content">
      @if (!showThankYouModal()) {
        <span class="c-rateModal__title">{{ 'home.lobby.modals.rate.title' | translate | uppercase }}</span>
        <div class="c-rateModal__stars">
          @for (star of starsArray; track star; let i = $index) {
            <span
              id="star-{{ i }}"
              class="icons-sprite star-outline"
              (click)="rate(i + 1)"></span>
          }
        </div>
        <div class="c-rateModal__message">
          @switch (rateValue) {
            @case (1) {
              <span>{{ 'home.lobby.modals.rate.rate-message-1' | translate | uppercase }}</span>
            }
            @case (2) {
              <span>{{ 'home.lobby.modals.rate.rate-message-2' | translate | uppercase }}</span>
            }
            @case (3) {
              <span>{{ 'home.lobby.modals.rate.rate-message-3' | translate | uppercase }}</span>
            }
            @case (4) {
              <span>{{ 'home.lobby.modals.rate.rate-message-4' | translate | uppercase }}</span>
            }
            @case (5) {
              <span>{{ 'home.lobby.modals.rate.rate-message-5' | translate | uppercase }}</span>
            }
            @default {
              <span></span>
            }
          }
        </div>
        @if (rateValue !== 0) {
          <slotcom-button
            class="c-button--pink"
            (safeClick)="rateButton()"
            audioType="functionality">
            {{ 'home.buttons.rate' | translate | uppercase }}
          </slotcom-button>
        }
      } @else {
        <div class="c-thankYou">
          <span class="c-thankYou__title">{{ 'home.lobby.modals.rate.thank-you-title' | translate | uppercase }}</span>
          <div class="c-thankYouModal__hearts">
            @for (heart of heartsArray; track heart) {
              <span class="icons-sprite heart"></span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
